// Supermove
import {gql} from '@supermove/graphql';
import {withFragment} from '@supermove/utils';

const edit = withFragment(
  (jobTruck) => ({
    jobTruckId: (jobTruck as any).id,
    jobId: (jobTruck as any).jobId,
    truckId: (jobTruck as any).truckId,
  }),
  gql`
    fragment JobTruckForm_edit on JobTruck {
      id
      jobId
      truckId
    }
  `,
);

const _new = ({jobId, truckId}: any) => ({
  jobTruckId: null,
  jobId,
  truckId,
});

const toForm = ({jobTruckId, jobId, truckId}: any) => ({
  jobTruckId,
  jobId,
  truckId,
});

const toMutation = ({jobTruckId, jobId, truckId}: any) => ({
  jobTruckId,
  jobId,
  truckId,
});

const JobTruckForm = {
  edit,
  new: _new,
  toForm,
  toMutation,
};

export default JobTruckForm;
